import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
import { news, spotlight, usefulLinks } from '../data/homepage';
function SectionTitle({
  id,
  children
}: {
  id: string;
  children: React.ReactNode;
}) {
  return <div className="flex items-center gap-4" data-id="element-1749" data-mp="3gjsoa2eybj7g">
      <h2 id={id} className="shrink-0 text-2xl font-extrabold uppercase tracking-wide text-ville-navy" data-id="element-1750" data-mp="3lgsympiu384d">
        {children}
      </h2>
      <span className="h-px flex-1 bg-ville-coral" aria-hidden="true" data-id="element-1751" data-mp="d2k7llvympeb" />
    </div>;
}
const coralButton = 'inline-flex items-center rounded-sm border-2 border-ville-coral px-6 py-3 text-sm font-bold uppercase tracking-wider text-ville-coral transition-colors duration-150 ease-ville hover:bg-ville-coral hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-coral focus-visible:ring-offset-2';
export function News() {
  return <>
      <section aria-labelledby="spotlight-titre" className="bg-white py-14 lg:py-20" data-id="element-1752" data-mp="10rdbc4itq1jh">
        <div className="mx-auto max-w-[1500px] px-5 lg:px-10" data-id="element-1753" data-mp="2xritjpsl1tr2">
          <SectionTitle id="spotlight-titre" data-id="element-1754" data-mp="2xs258orn3lwn">{spotlight.eyebrow}</SectionTitle>

          <div className="mt-8 grid items-center gap-10 lg:grid-cols-[minmax(0,46%)_minmax(0,1fr)] lg:gap-16" data-id="element-1755" data-mp="2su8x3q6s0htq">
            <img src={spotlight.poster} alt="" className="w-full rounded-sm object-cover shadow-xl shadow-ville-navy/10" data-id="element-1756" data-mp="37iwodk9la5dv" />

            <div data-id="element-1757" data-mp="3ggyw0intvwa4">
              <h3 className="text-2xl font-extrabold uppercase leading-snug tracking-wide text-ville-navy" data-id="element-1758" data-mp="3ggfeh323b9wm">
                {spotlight.title}
              </h3>
              <p className="mt-4 text-[17px] leading-relaxed text-ville-navy/80" data-id="element-1759" data-mp="3qgpu0ublktey">{spotlight.teaser}</p>

              <ul className="mt-6 grid gap-x-8 gap-y-2 sm:grid-cols-2" data-id="element-1760" data-mp="3lh3bq6gwwmza">
                {spotlight.highlights.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-ville-navy/80" data-id="element-1761" data-mp="1w2yitqdme1he">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-ville-coral" aria-hidden="true" data-id="element-1762" data-mp="1r56jibanbd36" />
                    {item}
                  </li>)}
              </ul>

              <a href="#accueil" className={`mt-8 ${coralButton}`} data-id="element-1763" data-mp="2ktcpjrt5qv4d">
                {spotlight.cta}
              </a>
            </div>
          </div>
        </div>
      </section>

      <section aria-labelledby="une-titre" className="bg-ville-mist py-14 lg:py-20" data-id="element-1764" data-mp="2us1wwqnfgx6d">
        <div className="mx-auto grid max-w-[1500px] gap-10 px-5 lg:grid-cols-[minmax(0,1fr)_minmax(0,420px)] lg:gap-14 lg:px-10" data-id="element-1765" data-mp="2zpafutgeh58o">
          <div data-id="element-1766" data-mp="33q44jp1o2o2m">
            <SectionTitle id="une-titre" data-id="element-1767" data-mp="33pkko2sghply">À la une</SectionTitle>

            <ul className="mt-8 divide-y divide-ville-coral/40 border-b border-ville-coral/40" data-id="element-1768" data-mp="38jyjkf6buevd">
              {news.map(item => <li key={item.id} className="py-8 first:pt-0" data-id="element-1769" data-mp="3djkyct1t036a">
                  <article className="grid gap-5 sm:grid-cols-[110px_minmax(0,1fr)] sm:gap-8" data-id="element-1770" data-mp="3ii4icnwu74w0">
                    <p className="flex items-start gap-1.5 leading-none" data-id="element-1771" data-mp="3ngpo12uuygru">
                      <span className="font-display text-5xl font-extrabold text-ville-coral" data-id="element-1772" data-mp="1bsujj7ylp2my">{item.day}</span>
                      <span className="mt-1 flex flex-col text-xs font-bold text-ville-coral" data-id="element-1773" data-mp="16sg8ri5m7el8">
                        <span data-id="element-1774" data-mp="11tlk3zkyuvt7">{item.month}</span>
                        <span data-id="element-1775" data-mp="11whhnmswjih4">{item.year}</span>
                      </span>
                    </p>

                    <div className="min-w-0" data-id="element-1776" data-mp="wxocchnrqxs1">
                      <h3 className="text-lg font-extrabold uppercase leading-snug tracking-wide text-ville-navy" data-id="element-1777" data-mp="1ujc06e65s7ry">
                        {item.title}
                      </h3>
                      <p className="mt-3 text-[15px] leading-relaxed text-ville-navy/75" data-id="element-1778" data-mp="1kszc4bz4xwh2">{item.excerpt} […]</p>
                      <a href="#accueil" aria-label={`Lire : ${item.title}`} className="mt-5 grid h-11 w-11 place-items-center rounded-sm border-2 border-ville-coral text-ville-coral transition-colors duration-150 ease-ville hover:bg-ville-coral hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-coral focus-visible:ring-offset-2" data-id="element-1779" data-mp="1fuxwy24tyhav">
                        <PlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-1780" data-mp="1xxk7xjlxxolv" />
                      </a>
                    </div>
                  </article>
                </li>)}
            </ul>
          </div>

          <aside aria-labelledby="liens-titre" className="rounded-sm bg-white p-7 lg:p-9" data-id="element-1781" data-mp="2brlaypjxdxs1">
            <SectionTitle id="liens-titre" data-id="element-1782" data-mp="2gqenaenh7iqm">Liens utiles</SectionTitle>

            <ul className="mt-7 space-y-5" data-id="element-1783" data-mp="2gpmqj0i57eyr">
              {usefulLinks.map(link => {
              const content = <>
                    <span className="min-w-0 flex-1 text-[17px] font-bold text-ville-navy" data-id="element-1784" data-mp="270363qes7d1s">{link.label}</span>
                    <PlusIcon className="h-5 w-5 shrink-0 text-ville-coral transition-transform duration-150 ease-ville group-hover:rotate-90" aria-hidden="true" data-id="element-1785" data-mp="2upxnmla1ppsd" />
                  </>;
              const classes = 'group flex w-full items-center gap-4 border-l-4 border-ville-coral py-1 pl-4 text-left transition-colors duration-150 ease-ville hover:border-ville-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-coral';
              return <li key={link.label} data-id="element-1786" data-mp="531gzlxfyswa">
                    {link.to ? <Link to={link.to} className={classes} data-id="element-1787" data-mp="555i5w3yhdsv">
                        {content}
                      </Link> : <a href="#accueil" className={classes} data-id="element-1788" data-mp="e3zj1yobkqc8">
                        {content}
                      </a>}
                  </li>;
            })}
            </ul>
          </aside>
        </div>
      </section>
    </>;
}